export enum StorageKey {
  ACCESS_TOKEN = 'access-token',
  REFRESH_TOKEN = 'refresh-token'
}
